/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, Jan 2022
 * @flow
 */

import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import PopupHeader from '../../../../components/PopupHeader';
import Button from '../../../../components/Button';
import SlotContent from '../Slot/SlotContent';
import classes from './CubbyLayoutPopup.module.css';
import FireboardUtils from '../../../../util/fireboard-util';

const CubbyLayoutPopup = props => {
  const [rowArray, setRowArray] = useState([]);
  const [columnArray, setColumnArray] = useState([]);
  const [selectedSlots, setSelectedSlots] = useState(new Map());

  const {
    closePopup,
    twoDimensionSlot,
    buttonText,
    onMoveSlotOrder,
  } = props;
  const storeInfo = useSelector(state => state.storeInfo);
  const { storeCubby } = storeInfo?.data || {};
  const { rowCount, columnCount } = storeCubby || {};

  useEffect(() => {
    setRowArray(Array.from({ length: rowCount }, (_, rowIndex) => ({ id: `row-${rowIndex}` })));
    setColumnArray(Array.from({ length: columnCount }, (_, colIndex) => ({ id: `col-${colIndex}` })));
  }, [rowCount, columnCount]);

  const onSelectSlot = slot => {
    const mapObj = new Map();
    mapObj.set(slot.id, slot);
    setSelectedSlots(mapObj);
  };

  const onAction = () => {
    onMoveSlotOrder && onMoveSlotOrder(selectedSlots);
  };

  const isSlotAvailable = () => {
    const { slots } = storeCubby || {};
    if (slots && Array.isArray(slots) && slots.length > 0) {
      return true;
    }
    return false;
  };

  const renderBody = () => {
    return (
      rowArray.map((row, rowIndex) =>
        <div key={row.id} className={classes.cubbyRowWrapper}>
          {columnArray.map((col, colIndex) => {
            const slot = twoDimensionSlot[rowIndex][colIndex];
            const check = slot?.checkData || {};
            const occupied = !FireboardUtils.isObjectBlank(check);
            return (
              <div key={col.id} className={classes.cubbyWrapper}>
                <Header
                  occupied={occupied}
                  slot={slot}
                  selectedSlots={selectedSlots}
                  onSelectSlot={onSelectSlot}
                />
                {occupied && (
                  <SlotContent
                    check={check}
                    showDeliveryVendor={false}
                    showMarketplaceVendor={false}
                  />
                )}
              </div>
            )
          })}
        </div>
      )
    );
  };

  return (
    <div className={classes.container}>
      <PopupHeader onClose={closePopup} />
      <div className={classes.cubbiesWrapper}>
        {isSlotAvailable()
          ? renderBody()
          : <div className={classes.noCubbyText}>No cubby found!!!</div>
        }
      </div>
      <div className={classes.buttonWrapper}>
        <Button disabled={selectedSlots.size === 0} className={classes.button} onClick={onAction}>
          <span className={classes.buttonText}>{buttonText}</span>
        </Button>
      </div>
    </div>
  );
};

export default CubbyLayoutPopup;

CubbyLayoutPopup.propTypes = {
  closePopup: PropTypes.func.isRequired,
  twoDimensionSlot: PropTypes.arrayOf(PropTypes.array),
  buttonText: PropTypes.string.isRequired,
  onMoveSlotOrder: PropTypes.func.isRequired,
};

CubbyLayoutPopup.defaultProps = {
  closePopup: () => { },
  twoDimensionSlot: [[]],
  buttonText: 'Submit',
  onMoveSlotOrder: () => { },
};

const Header = ({ slot, occupied, selectedSlots, onSelectSlot }) => {
  const onSelect = () => {
    onSelectSlot && onSelectSlot(slot);
  };

  return (
    <div className={classes.slotHeader}>
      {!occupied && (
        <div className={classes.checkMarkWrapper} onClick={onSelect}>
          {selectedSlots.has(slot?.id) && <span className={classes.checkMark}>&#10003;</span>}
        </div>
      )}
      <span className={classes.slotName}>{slot?.name}</span>
    </div>
  );
};
